import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatSnackBar, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SnackbarComponent {

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: { text: string, dismissText: string, progress: { show: boolean, mode: any, perc: number } },
    private _snackbar: MatSnackBar
  ) { }

  public dismiss(): void {
    this._snackbar.dismiss();
  }
}
